module.exports = __webpack_public_path__ + "img/1.2db38575.png";